import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AppConstants } from '../../utilities/constant';
import { ToastService } from '../../services/toast.service';
import { addUniqueEntry,isNotEmptyArray } from '../../utilities/utils';
import { LanguageSupportService } from '../../services/language-support.service';
import { ShareValuesService } from '../../services/sharedValues/share-values.service';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-section-view',
  templateUrl: './section-view.component.html',
  styleUrls: ['./section-view.component.scss'],
})
export class SectionViewComponent implements OnInit, OnChanges {
  public accordionOpen = false;
  public question: any;
  public notes: any;
  public compliance: any;
  public subSections = [];
  @Input() selectedView: any;
  @Output() toggle = new EventEmitter<void>();
  @Output() addHazardDetail = new EventEmitter<void>();
  @Output() editHazardDetails = new EventEmitter<void>();
  @Input() selectedSection: any;
  @Input() roadmapName : string;
  @Input() roadmapStatus: string;
  @Input() isCustom: string;
  @Input() serviceMachineId: string;
  @Input() isRiskReassessment: boolean;
  selectedLanguage: string = this.serviceMulti.getDefaultLanguage();
  @Input() roadmapId: string;
   
  complianceOptions = [
    { value: 'yesCompliant', label: 'Yes, Compliant' },
    { value: 'notCompliant', label: 'Not Compliant' },
    { value: 'notApplicable', label: 'Not applicable' },
    { value: 'hazard', label: 'Report Hazard' }
  ];
  hazardRatingList = [
    { listName: 'Probability of Occurrence', listNameView: this.selectedLanguage == 'en' ? 'Likelihood Of Occurences(LO)' : 'Eintrittswahrscheinlichkeit (LO)', val: 'PO', weightagesList: this.sharedValue.weightagesList, dataChrn: {}, dataIhrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, rating: '' },
    { listName: 'Frequency of Exposition', listNameView: this.selectedLanguage == 'en' ? 'Frequency Of Exposure(FE)' : 'Häufigkeit der Gefährdung(FE)', val: 'FE', weightagesList: this.sharedValue.FEweightagesList, dataChrn: {}, dataIhrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, rating: '' },
    { listName: 'Degree of Severity', listNameView: this.selectedLanguage == 'en' ? 'Degree Of Possible Harm(DPH)' : 'Schweregrad der Verletzung (DPH)', val: 'SD', weightagesList: this.sharedValue.DPEweightagesList, dataChrn: {}, dataIhrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, rating: '' },
    { listName: 'Number of Persons Exposed', listNameView: this.selectedLanguage == 'en' ? 'Number of Persons at Risk(NPE)' : 'Anzahl der gefährdeten Personen (NPE)', val: 'NP', weightagesList: this.sharedValue.NPEweightagesList, dataChrn: {}, dataRiskChrn: {}, dataRiskIhrn: {}, dataIhrn: {}, rating: '' }];
    queryParams: any={};
 
 
  constructor(private route: ActivatedRoute,
    public backendService: BackendCallService,
    private toastService: ToastService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private serviceMulti: LanguageSupportService,
    private sharedValue: ShareValuesService,
    private translate: TranslateService) {
    this.route.queryParams.subscribe(async (params) => {
      this.queryParams=params;
    });
   }

  ngOnInit() { 
    this.sharedValue.applyHazardRatingLanguage(this.hazardRatingList, this.selectedLanguage);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedView'] || changes['selectedSection']) {
      this.handleViewChanges();
    }
  }

  onRadioSelectionChanged(event: any,step) {
    const selectedValue = event.detail.value;
    let selectedOption = this.complianceOptions.find(option => option.value === selectedValue).label;
    
    if (selectedOption == 'Yes, Compliant') {
      step.answers[0].selectColorClass = 'btn-primary';
      step.answers[0].selectedValue = 'yesCompliant';
    }
    else if(selectedOption == 'Not Compliant'){
      step.answers[0].selectColorClass = 'btn-primary';
      step.answers[0].selectedValue = 'notCompliant';
    }
    else if(selectedOption == 'Not applicable')
    {
      step.answers[0].selectColorClass = 'btn-primary';
      step.answers[0].selectedValue = 'notApplicable';
    }
    else if(selectedOption =='Report Hazard')
    {
      step.answers[0].selectColorClass = 'btn-danger';
      step.answers[0].selectedValue = 'hazard';
    }
  }

  addHazardDetails(index, step) {
    if (step.stepBody) {
      const data = { sectionName: step.sectionName, subSectionName: step.subSectionName, index, roadMapName: this.roadmapName, question: step.stepBody };
      const navigationExtras: NavigationExtras = {
        queryParamsHandling: 'merge',        
      };
      const hazardInfo = {
        sectionData: data,
        hazardData: step,
        isCustom:this.isCustom,
        roadmapStatus: this.roadmapStatus,
        isRiskReassessment: this.isRiskReassessment,
        addNewHazard: true,
        serviceMachineId:this.serviceMachineId
      };
      // Store the parameter in sessionStorage
      sessionStorage.setItem('hazardInfo', JSON.stringify(hazardInfo));
      this.addHazardDetail.emit();
      //this.router.navigate([window.location.pathname, 'add-hazard-details'],navigationExtras);
    } else {
      this.toastService.presentToast(this.translate.instant('please_complete_all_mandatory_fields'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
    }

  }  

  setRadioButtonSelection(element) {
    if (element.yesComplaint) {
      element.selectedValue = 'yesCompliant';
      element.selectColorClass = 'btn-primary';
    } else if (element.notCompliant) {
      element.selectedValue = 'notCompliant';
      element.selectColorClass = 'btn-primary';
    } else if (element.notApplicable) {
      element.selectedValue = 'notApplicable';
      element.selectColorClass = 'btn-primary';
    } else if (element.hazard) {
      element.selectedValue = 'hazard';
      element.selectColorClass = 'btn-danger'
    } 
  }

  /**
   * Handles view changes
   */
  private handleViewChanges() {
    this.subSections = [];
    if (this.selectedView?.sectionName == this.selectedSection?.sectionName) {
      this.selectedView?.subSections?.forEach(subSection => {
        // Ensure steps are nested within each subsection
        subSection.steps.forEach(step => {
          step['accordionOpen'] = false;
            step.answers.forEach(element => {
                this.setRadioButtonSelection(element);
            });
          });
        this.subSections.push(subSection); // Push the entire subSection with its steps
        console.log(this.subSections);
      });
    }
  }

  hazardCheckLists: any;
  editHazard(eachHazard, step) {
    this.backendService.getFourEyeQualityHazardCheckListsInfo(eachHazard.id).then((res: any) => {
      if (res) {
        this.hazardCheckLists = res;
        this.constructHazardHrnStructure(eachHazard, step);
      }
    }).catch(err => {
      console.log('getting issue in fetching four eye quality hazard checklist info :', err);
    });

  }

  async constructHazardHrnStructure(eachHazard, step) {
    if (isNotEmptyArray(this.hazardCheckLists.hrnCalculations)) {
      const machineModes = [];
      const machineModesWithIds = [];
      const riskmachineModes = [];
      const riskMachineModesWithIds = [];
      this.hazardCheckLists?.hrnCalculations.forEach(_hrn => {
        if (_hrn.type == 'Current') {
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(machineModes, _val.mode));}
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(machineModesWithIds, { mode: _val.mode, id: _val.id, type: _hrn.type }));}
        }
        if (_hrn.type == 'Risk Reassessment Current') {
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(riskmachineModes, _val.mode));}
          if (isNotEmptyArray(_hrn.values)) {_hrn.values.forEach(_val => addUniqueEntry(riskMachineModesWithIds, { mode: _val.mode, id: _val.id, type: _hrn.type }));}
        }
      });
      this.hazardCheckLists.hrnCalculations.forEach(_hrn => {
        if (_hrn.type == 'Current' || _hrn.type == 'current') {
          this.hazardRatingList.forEach(_hr => {
            machineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };
                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }


                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po;
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataChrn[_mode] = body;
                }
              });
            });
          });
        } else if (_hrn.type == 'Indicative' || _hrn.type == 'indicative') {
          this.hazardRatingList.forEach(_hr => {
            machineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };

                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }

                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataIhrn[_mode] = body;
                }
              });
            });
          });
        } else if (_hrn.type == 'Risk Reassessment Current') {
          this.hazardRatingList.forEach(_hr => {
            riskmachineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };

                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }

                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataRiskChrn[_mode] = body;
                }
              });
            });
          });
        } else if (_hrn.type == 'Risk Reassessment Indicative') {
          this.hazardRatingList.forEach(_hr => {
            riskmachineModes.forEach(_mode => {
              _hrn.values.forEach(_val => {
                if (_mode == _val.mode) {
                  const rating = _val.rating;//+_val.po * +_val.sd * +_val.fe * +_val.np;
                  const body = {
                    label: '',
                    value: '',
                    id: '',
                    rating
                  };

                  if (_hr.val == 'PO') {
                    if (_val.po == '1') {
                      body.value = '0.033';
                    }
                    else if (_val.po == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.po == '3') {
                      body.value = '1';
                    }
                    else if (_val.po == '4') {
                      body.value = '2';
                    }
                    else if (_val.po == '5') {
                      body.value = '5';
                    }
                    else if (_val.po == '6') {
                      body.value = '8';
                    }
                    else if (_val.po == '7') {
                      body.value = '10';
                    }
                    else if (_val.po == '8') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'SD') {
                    if (_val.sd == '1') {
                      body.value = '0.1';
                    }
                    else if (_val.sd == '2') {
                      body.value = '0.5';
                    }
                    else if (_val.sd == '3') {
                      body.value = '1';
                    }
                    else if (_val.sd == '4') {
                      body.value = '2';
                    }
                    else if (_val.sd == '5') {
                      body.value = '4';
                    }
                    else if (_val.sd == '6') {
                      body.value = '8';
                    }
                    else if (_val.sd == '7') {
                      body.value = '15';
                    }
                  }
                  else if (_hr.val == 'FE') {
                    if (_val.fe == '1') { body.value = '0.1'; }
                    else if (_val.fe == '2') { body.value = '0.2'; }
                    else if (_val.fe == '3') { body.value = '1'; }
                    else if (_val.fe == '4') { body.value = '1.5'; }
                    else if (_val.fe == '5') { body.value = '2.5'; }
                    else if (_val.fe == '6') { body.value = '4'; }
                    else if (_val.fe == '7') { body.value = '15'; }
                  }
                  else if (_hr.val == 'NP') {
                    if (_val.np == '1') { body.value = '1'; }
                    else if (_val.np == '2') { body.value = '2'; }
                    else if (_val.np == '3') { body.value = '4'; }
                    else if (_val.np == '4') { body.value = '8'; }
                    else if (_val.np == '5') { body.value = '12'; }
                  }

                  if (_hr.val == 'PO') {body.id = _val.po;}
                  else if (_hr.val == 'SD') {body.id = _val.sd;}
                  else if (_hr.val == 'FE') {body.id = _val.fe;}
                  else if (_hr.val == 'NP') {body.id = _val.np;}

                  // if (_hr.val == 'PO') body.value = _val.po
                  // else if (_hr.val == 'SD') body.value = _val.sd
                  // else if (_hr.val == 'FE') body.value = _val.fe
                  // else if (_hr.val == 'NP') body.value = _val.np

                  const matchedWeight = _hr.weightagesList.find(_wght => _wght.value == body.value);
                  if (matchedWeight) {body.label = matchedWeight.label;}
                  _hr.dataRiskIhrn[_mode] = body;
                }
              });
            });
          });
        }
      });
      this.hazardCheckLists.machineModes = machineModes;
      this.hazardCheckLists.machineModesWithIds = machineModesWithIds;
      this.hazardCheckLists.riskmachineModes = riskmachineModes;
      this.hazardCheckLists.riskMachineModesWithIds = riskMachineModesWithIds;
      await this.goToHazrdsPage(eachHazard, step);
    } else {
      this.hazardCheckLists.machineModes = [];
      this.hazardCheckLists.machineModesWithIds = [];
      this.hazardCheckLists.riskmachineModes = [];
      this.hazardCheckLists.riskMachineModesWithIds = [];
      await this.goToHazrdsPage(eachHazard, step);
    }
  }
  @Input() sectionName: string;
  @Input() subSectionName: string;
  goToHazrdsPage(eachHazard, step) {
    step.hazardTypesData = [];
    const sectionInfo = {
      sectionName: this.sectionName,
      subSectionName: this.subSectionName,
      index: 0,
      roadMapName: this.roadmapName
    };
    const hazrdInfo = {
      id: eachHazard.id,
      stepBody: '',
      stepNote: '',
      answers: null,
      hazardCount: 0,
      isListItemOpened: true,
      compliance: 'hazard',
      hazardName: this.hazardCheckLists?.name,
      hazardType: this.hazardCheckLists?.hazardType,
      hazardRatingList: this.hazardRatingList,
      machineModes: this.hazardCheckLists?.machineModes,
      machineModesWithIds: this.hazardCheckLists?.machineModesWithIds,
      riskmachineModes: this.hazardCheckLists?.riskmachineModes,
      riskMachineModesWithIds: this.hazardCheckLists?.riskMachineModesWithIds,
      pickInitialHazard: this.hazardCheckLists?.initial_hazard,
      pickInitialHazardValue: this.hazardCheckLists?.initial_hazard,
      pickControlMeasure: this.hazardCheckLists?.counter_measure,
      pickCntrlMeasureValue: this.hazardCheckLists?.counter_measure,
      determinePlrValue: this.hazardCheckLists?.plr,
      recommendedCategory: this.hazardCheckLists?.category,
      hazardImagesList: this.hazardCheckLists?.hazardMedia,
      plrObj: this.hazardCheckLists.plrObj
    };
    this.hazardCheckLists.hazardType.forEach(_ht => {
      const sourceBody = [];
      const consequeceBody = [];
      _ht.hazardSources.forEach(_hts => { sourceBody.push(_hts.source); });
      _ht.hazardConsequences.forEach(_hts => { consequeceBody.push(_hts.consequences); });
      step.hazardTypesData.push({ hazardType: _ht.hazardTypeName || _ht.type, source: sourceBody, consequences: consequeceBody });
    });
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'merge',
    };
    const hazardInfo = {
      isEditingFourEyeQuality: true,
      sectionData: sectionInfo,
      isCustom:this.isCustom,
      hazardData: hazrdInfo,
      roadmapStatus: this.roadmapStatus,
      isRiskReassessment: this.isRiskReassessment,
      addNewHazard: false
    };
    // Store the parameter in sessionStorage
    sessionStorage.setItem('hazardInfo', JSON.stringify(hazardInfo));
    //this.router.navigate([window.location.pathname, 'add-hazard-details'],navigationExtras);
    this.editHazardDetails.emit();
  }


  fnGetOptionName(value)
  {
    let optionname = '';
    if(value != '')
      optionname = this.complianceOptions.find(it=>it.value == value)?.label == "Report Hazard" ? "Hazard Reported" : this.complianceOptions.find(it=>it.value == value)?.label;
    return optionname;
  }

  /**
   * Toggles accordion
   * 
   * @param step 
   * @param stepIndex 
   */
  public toggleAccordion(step, stepIndex) {
    // Loop through all subsections
    this.subSections.forEach((subSection) => {
      // Check if the current subsection contains the clicked step
      if (subSection.steps.includes(step)) {
        // Loop through all steps in the current subsection
        subSection.steps.forEach((stp, i) => {
          // Toggle the clicked accordion and close all others
          stp.accordionOpen = i === stepIndex ? !stp.accordionOpen : false;
        });
      }
    });
  }

/**
 * Deletes subsection
 * 
 * @param subsection 
 * @param index 
 */
public deleteSubsection(subsection, index: number) {
    let subSectionId: any;
    if(subsection.subSection_Id)  {
      this.selectedView.subSections.forEach((element, i) => {
        if (element.subSection_Id == subsection.subSection_Id) {
          subSectionId = element.subSection_Id;
          this.subSections.splice(index, 1);
          return;
        }
      });
      const payload = {
        id: this.roadmapId,
        serviceMachineId: this.queryParams.serviceMachineId,
        projectId: this.queryParams.project_id,
        section: [{
          sectionId: this.selectedView.sectionId,
          isDelete: false,
          subSection: [{
            subSection_Id: subSectionId,
            isDelete: true,
            steps: [{
              id: '',
              isDelete: false
            }]
          }]
        }]
      };
      this.backendService.deleteRoadmapSectionsData(payload).subscribe(
        (data: any) => {
          this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        },
        err => {
          this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      );
    }else {
      this.subSections.splice(index, 1);
    }

  }

/**
 * Deletes step
 * 
 * @param step 
 * @param index 
 * @param event 
 */
public deleteStep(step, index: number, event: Event) {
    event.stopPropagation();
    let subSectionId: any;
    if(step.id)  {
      this.selectedView.subSections.forEach(element => {
        subSectionId = element.subSection_Id;
        element.steps.forEach((eachStep, i) => {
          if (step.id === eachStep.id) {
            element.steps.splice(i, 1);
          }
        });
      });
  
      const payload = {
        id: this.roadmapId,
        serviceMachineId: this.queryParams.serviceMachineId,
        projectId: this.queryParams.project_id,
        section: [
          {
            sectionId: this.selectedView.sectionId,
            isDelete: false,
            subSection: [
              {
                subSection_Id: subSectionId,
                isDelete: false,
                steps: [
                  {
                    id: step.id,
                    isDelete: true
                  }
                ]
              }
            ]
          }
        ]
      };
      this.backendService.deleteRoadmapSectionsData(payload).subscribe(
        (data: any) => {
          this.toastService.presentToast(data, 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        },
        (err) => {
          this.toastService.presentToast(err.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      );
    }else {
      this.subSections.forEach((element, i) => {
        element.steps.splice(index, 1)
      });
    }
  }

  /**
   * Adds new section
   */
  public addNewSection() {
    const newSubSection = {
      id: null,
      subSection_Id: '',
      subSectionName: `Sub Section ${this.subSections.length + 1}`,
      createdDate: new Date().toISOString(),
      steps: []
    };
    this.subSections.push(newSubSection);
  }

  /**
   * Adds new step
   * 
   * @param subSectionIndex 
   */
  public addNewStep(subSectionIndex: number) {
    const newStep = {
      id: '',
      stepBody: `New Step ${this.subSections[subSectionIndex].steps.length + 1}`,
      stepNote: `New Step ${this.subSections[subSectionIndex].steps.length + 1} note`,
      padLock: false,
      createdDate: new Date().toISOString(),
      answers : [{ selectedValue: '' ,selectColorClass: ''}],
      hazardCount: 0,
      accordionOpen: false
    };
    this.subSections[subSectionIndex].steps.push(newStep);
  }

 
  /**
   * Gets answer
   * 
   * @param step 
   * @returns selectedValue
   */
  getAnswer(step: any) {
    if (!step.answers) {
      step.answers = [{}]; // Initialize answers as an array with a default object
    }
    return step.answers[0]?.selectedValue;
  }
}
